<h2 class="section-title">{{ 'settings.analytical.form.title' | translate }}</h2>
<form [formGroup]="activityForm" (ngSubmit)="save()">
    <div class="card form-grid">
        <div class="form-field">
            <label for="nameInput" class="form-field__label form-field__label--required">
                {{ 'settings.analytical.form.name' | translate }}
            </label>
            <input
                id="nameInput"
                pInputText
                type="text"
                formControlName="name"
                [placeholder]="'settings.analytical.form.placeholder.name' | translate" />
            @if (activityForm.get('name')?.errors?.required && activityForm.get('name')?.touched) {
                <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
            }
        </div>
        <div class="form-field">
            <label for="descriptionInput" class="form-field__label">
                {{ 'settings.analytical.form.description' | translate }}
            </label>
            <textarea
                id="descriptionInput"
                pTextarea
                formControlName="description"
                [placeholder]="'settings.analytical.form.placeholder.description' | translate"></textarea>
        </div>
        <div class="form-field">
            <label for="entitiesInput" class="form-field__label">
                {{ 'settings.analytical.form.selectEntity' | translate }}
                <span
                    class="material-symbols-outlined icon-sm align-middle cursor-help"
                    [pTooltip]="'settings.analytical.form.infotips.selectEntity' | translate"
                    >info</span
                >
            </label>
            <p-multiSelect
                inputId="entitiesInput"
                [options]="entitiesOptions"
                formControlName="entities"
                optionLabel="name"
                display="chip"
                [placeholder]="'settings.analytical.form.placeholder.selectEntity' | translate"
                [filterPlaceHolder]="'common.search' | translate">
                <ng-template let-selectedItems pTemplate="selectedItems">
                    @if (selectedItems?.length > 0) {
                        <div class="chip-list">
                            <!-- The first two entities, then "…" listing the others in its tooltip. -->
                            @for (entity of selectedItems.slice(0, 2); track entity) {
                                <p-chip [label]="entity.name" />
                            }
                            @if (selectedItems.length > 2) {
                                <p-chip
                                    label=". . ."
                                    [pTooltip]="getTooltipEntities(selectedItems)"
                                    tooltipPosition="top" />
                            }
                        </div>
                    }
                </ng-template>
            </p-multiSelect>
        </div>
    </div>
    <div class="form-actions">
        @if (selectedAnalyticCategory) {
            <p-button
                class="form-actions__start"
                severity="danger"
                [text]="true"
                icon="ms ms-delete"
                [label]="'components.settingsForm.button.remove' | translate"
                (onClick)="onDelete()" />
        }
        <p-button severity="secondary" [label]="'common.cancel_button' | translate" (onClick)="close()" />
        <p-button type="submit" [label]="'common.confirm_button' | translate" />
    </div>
</form>
<p-confirmDialog />
